<template>
    <v-container>
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card class="justify-center">
                <v-card-title
                        dark
                        class="text--primary justify-center"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text class="text-sm-center">
                    <strong v-if="band_cellphone1 === false && band_cellphone2 === false">
                        {{$t('cellphone_wrong')}}<br>Tutor 1 y 2</strong>
                    <strong v-if="band_cellphone1 === false && band_cellphone2 === true">
                        {{$t('cellphone_wrong')}}<br>Tutor 1</strong>
                    <strong v-if="band_cellphone2 === false && band_cellphone1 === true">
                        {{$t('cellphone_wrong')}}<br>Tutor 2</strong>
                    <strong v-if="bandDifferentEmail1">
                        <br>{{$t('email_wrong')}}<br>Tutor 1</strong>
                    <strong v-if="bandDifferentEmail2">
                        <br>{{$t('email_wrong')}}<br>Tutor 2</strong>
                    <strong v-if="bandNoSchoolRegister === true">{{$t('msg_no_school')}}</strong>
                    <strong v-if="bandDifferentNumbers !== false">{{$t('msg_different_numbers')}}</strong>
                    <strong v-if="bandNoStudentRegister === true">{{$t('msg_no_students')}}</strong>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de Perfil Estudiante     -->
        <v-dialog v-model="dialogImageProfileStudent" persistent scrollable max-width="700px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfile2URL"
                            ref="clipperImageProfile3"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfileStudent()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront1" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <div class="flex">
                            <clipper-basic
                                    class="basic lg"
                                    :rotate="degrees"
                                    ref="clipperImageFront1"
                                    :src="imageFrontURL1">
                            </clipper-basic>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront1()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack1" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <div class="flex">
                            <clipper-basic
                                    class="basic lg"
                                    :rotate="degrees"
                                    ref="clipperImageBack1"
                                    :src="imageBackURL1">
                            </clipper-basic>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack1()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile1" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL1"
                            ref="clipperImageProfile1"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile1()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront2" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <div class="flex">
                            <clipper-basic
                                    class="basic lg"
                                    :rotate="degrees"
                                    ref="clipperImageFront2"
                                    :src="imageFrontURL2">
                            </clipper-basic>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront2()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack2" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <div class="flex">
                            <clipper-basic
                                    class="basic lg"
                                    :rotate="degrees"
                                    ref="clipperImageBack2"
                                    :src="imageBackURL2">
                            </clipper-basic>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack2()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile2" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <div class="flex">
                            <clipper-fixed
                                    class="basic lg"
                                    :src="imageProfileURL2"
                                    ref="clipperImageProfile2"
                                    :rotate="degrees"
                                    :round="true"
                                    preview="preview">
                            </clipper-fixed>
                        </div>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile2()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo de progreso    -->
        <v-dialog
                v-model="dialogProgress"
                max-width="500"
        >
            <div>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        <v-icon right dark>mdi-home-edit</v-icon>
                        {{$t('enviar_datos')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-flex xs12>
                    <v-progress-linear
                            color="white"
                            indeterminate
                            rounded
                            height="12"
                    ></v-progress-linear>
                </v-flex>
            </div>
        </v-dialog>
        <!--    Diálogo Modal para dar de Alta Estudiante(s)    -->
        <v-dialog v-model="dialogStudent" scrollable max-width="350">
            <ValidationObserver v-slot="{ invalid, reset }" ref="observer">
                <v-card>
                    <v-toolbar dark  color="primary">
                        <v-toolbar-title>
                            {{formTitle}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                icon
                                @click="dialogStudent = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap class="text-center">
                            <v-flex xs12 class="pt-3 pb-3 pl-3 pr-3">
<!--                                <ValidationProvider rules="required|image" ref="provider" v-slot="{ validate, errors }">-->
                                    <v-label>
                                        {{$t('foto_perfil')}}
                                    </v-label>
                                    <br>
                                    <v-avatar
                                            class="profile"
                                            color="grey"
                                            size="200"
                                    >
                                        <v-img :src="editedItem.avatar"
                                               v-if="editedItem.avatar"
                                        >
                                        </v-img>
                                    </v-avatar>
                                    <br>
                                    <br>
                                    <v-btn color="primary">
                                        <clipper-upload
                                                @input="dialogStudent = false, dialogImageProfileStudent = true, degrees = 0, ratio = 1.5"
                                                accept="image/*"
                                                v-model="imageProfile2URL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
<!--                                    <input type="file" @change="validate" />-->
<!--                                    <v-alert v-if="errors[0]" type="error" text>{{ errors[0] }}</v-alert>-->
<!--                                </ValidationProvider>-->
                            </v-flex>
                            <v-flex xs12>
                              <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                <v-autocomplete
                                    class="pl-3 pr-3"
                                    v-model="editedItem.idSchool"
                                    outlined
                                    :placeholder="$t('placeholder_choose_school')"
                                    prepend-icon="mdi-home-city"
                                    name="section"
                                    item-text="name"
                                    item-value="id"
                                    :label="$t('Escuelas')"
                                    :error-messages="errors[0]"
                                    :items="sections"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                                v-bind="data.attrs"
                                                :input-value="data.selected"
                                                @click="data.select"
                                        ><v-avatar>
                                          <img :src="data.item.logo"/>
                                        </v-avatar>
                                            {{ data.item.name }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                        <template v-if="typeof data.item !== 'object'">
                                            <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                          <v-list-item-avatar>
                                            <img :src="data.item.logo"/>
                                          </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                </v-autocomplete>
                              </ValidationProvider>
                            </v-flex>
                            <v-flex xs12>
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="editedItem.first_name"
                                            name="first_name_re"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            outlined
                                            :error-messages="errors[0]"
                                    >
                                    </v-text-field>
                                </ValidationProvider>
                            </v-flex>
                            <v-flex xs12>
                                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="editedItem.last_name"
                                            name="last_name_re"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            outlined
                                            :error-messages="errors[0]"
                                    >
                                    </v-text-field>
                                </ValidationProvider>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions class="text-center">
                        <v-btn
                                small
                                color="primary"
                                @click="dialogStudent = false"
                        >{{$t('cerrar')}}</v-btn>
                        <v-spacer/>
                        <v-btn
                                small
                                color="primary"
                                :disabled="invalid || resultProfile2URL === ''"
                                @click="addStudent()"
                        >{{$t('guardar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </ValidationObserver>
        </v-dialog>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-toolbar class="mb-5" dark color="primary">
                        <v-toolbar-title>
                            <v-icon right dark>mdi-home-edit</v-icon>
                            {{$t('btnRegistrarTutores')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        {{$t('msg_registro_inicial_01')}} <strong>{{$t('tutores')}}</strong>
                        {{$t('msg_registro_inicial_02')}} <strong>{{$t('estudiantes')}}</strong>.<br><br>
                        <v-divider></v-divider>
                        <br>
                        <v-form>
<!--                            <h3>{{$t('Escuelas')}}</h3>-->
<!--                            <br>-->
<!--                            <v-layout row wrap>-->
<!--                                <v-flex xs12 sm6>-->
<!--                                    <v-autocomplete-->
<!--                                            clearable-->
<!--                                            class="pl-3 pr-3"-->
<!--                                            v-model="idSchool"-->
<!--                                            :items="items"-->
<!--                                            :search-input.sync="search"-->
<!--                                            :loading="isLoadingSchools"-->
<!--                                            no-data-text="Ningún Resultado"-->
<!--                                            item-text="name"-->
<!--                                            item-value="id"-->
<!--                                            prepend-icon="mdi-home-city"-->
<!--                                            :filter="customFilter"-->
<!--                                            :label="$t('catalogo_escuelas')"-->
<!--                                            :error-messages="errores.idSchool"-->
<!--                                            outlined-->
<!--                                            autocomplete="off"-->
<!--                                    >-->
<!--                                        <template v-slot:selection="data">-->
<!--                                            <v-chip-->
<!--                                                    v-bind="data.attrs"-->
<!--                                                    :input-value="data.selected"-->
<!--                                                    @click="data.select"-->
<!--                                            >-->
<!--                                                <v-avatar left>-->
<!--                                                    <v-img :src="data.item.logo"></v-img>-->
<!--                                                </v-avatar>-->
<!--                                                {{ data.item.name }}-->
<!--                                            </v-chip>-->
<!--                                        </template>-->
<!--                                        <template v-slot:item="data">-->
<!--                                            <template v-if="typeof data.item !== 'object'">-->
<!--                                                <v-list-item-content v-text="data.item"></v-list-item-content>-->
<!--                                            </template>-->
<!--                                            <template v-else>-->
<!--                                                <v-list-item-avatar>-->
<!--                                                    <img :src="data.item.logo">-->
<!--                                                </v-list-item-avatar>-->
<!--                                                <v-list-item-content>-->
<!--                                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>-->
<!--                                                </v-list-item-content>-->
<!--                                            </template>-->
<!--                                        </template>-->
<!--                                    </v-autocomplete>-->
<!--                                </v-flex>-->
<!--                            </v-layout>-->
<!--                            <v-divider></v-divider>-->
<!--                            <br>-->
                            <h3>{{$t('datos_tutor')}}</h3>
                            <br>
                            <v-checkbox
                              v-model="checkUniqueTutor"
                              :label="$t('register_only_tutor')"
                            >
                            </v-checkbox>
                            <v-alert
                                v-show="checkUniqueTutor"
                                icon="mdi-help"
                                prominent
                                text
                                type="info"
                            >
                              {{$t('msg_register_only_tutor')}}
                              <a href="mailto:help@intrare.app"><strong>help@intrare.app</strong></a>
                            </v-alert>
                            <br>
                            <h4>Tutor 1</h4>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="first_name"
                                            prepend-icon="mdi-account"
                                            name="first_name"
                                            :label="$t('Nombre')"
                                            :error-messages="errors_tutor1.first_name"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="last_name"
                                            prepend-icon="mdi-account-outline"
                                            name="last_name"
                                            :label="$t('Apellido')"
                                            :error-messages="errors_tutor1.last_name"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errors_tutor1.email"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="email_11"
                                            prepend-icon="mdi-email"
                                            name="email_11"
                                            :label="$t('email_confirm')"
                                            :error-messages="errors_tutor1.email"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <vue-phone-number-input
                                            class="pl-3 pr-3"
                                            default-country-code="MX"
                                            color="#D32F2F"
                                            valid-color="#2196F3"
                                            @update="onChange1"
                                            v-model="cellphoneMundial1"
                                            :translations="custom_cell_phone"
                                    ></vue-phone-number-input>
                                    <v-alert outlined v-if="errors_tutor1.cellNumber" type="error">{{errors_tutor1.cellNumber}}</v-alert>
                                </v-flex>
                            </v-layout><br>
                            <v-layout row wrap class="text-center">
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            v-if="resultFrontURL1 !== ''"
                                            :src="resultFrontURL1"
                                            width="auto"
                                            height="200px"
                                    ></v-img>
                                    <v-img
                                            v-else
                                            :src="require('../../public/img/icons/noimage.png')"
                                            width="auto"
                                            height="200px"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errors_tutor1.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errors_tutor1.idFront}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageFront1 = true, degrees = 0, ratio = 1.5"
                                                accept="image/*"
                                                v-model="imageFrontURL1"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
<!--                                <v-flex xs12 sm4 class="edge pt-3 pb-3 pl-3 pr-3">-->
<!--                                    <v-label>-->
<!--                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]-->
<!--                                    </v-label>-->
<!--                                    <br>-->
<!--                                    <v-img-->
<!--                                            v-if="resultBackURL1 !== ''"-->
<!--                                            :src="resultBackURL1"-->
<!--                                            width="auto"-->
<!--                                            height="200px"-->
<!--                                    ></v-img>-->
<!--                                    <v-img-->
<!--                                            v-else-->
<!--                                            :src="require('../../public/img/icons/noimage.png')"-->
<!--                                            width="auto"-->
<!--                                            height="200px"-->
<!--                                    ></v-img>-->
<!--                                    <br>-->
<!--                                    <v-alert-->
<!--                                            v-if="errors_tutor1.idBack"-->
<!--                                            type="error"-->
<!--                                            outlined-->
<!--                                            transition="scale-transition"-->
<!--                                    >-->
<!--                                        {{errors_tutor1.idBack}}-->
<!--                                    </v-alert>-->
<!--                                    <br>-->
<!--                                    <v-btn-->
<!--                                            color="primary">-->
<!--                                        <clipper-upload-->
<!--                                                @input="dialog = false, dialogImageBack1 = true, degrees = 0, ratio = 1.5"-->
<!--                                                accept="image/*"-->
<!--                                                v-model="imageBackURL1"-->
<!--                                        >-->
<!--                                            {{$t('subir_imagen')}}-->
<!--                                        </clipper-upload>-->
<!--                                    </v-btn>-->
<!--                                </v-flex>-->
<!--                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">-->
<!--                                    <v-label>-->
<!--                                        {{$t('foto_perfil')}}-->
<!--                                    </v-label>-->
<!--                                    <br>-->
<!--                                    <v-avatar-->
<!--                                            class="profile"-->
<!--                                            color="grey"-->
<!--                                            size="200"-->
<!--                                    >-->
<!--                                        <v-img :src="resultProfileURL1"-->
<!--                                               v-if="resultProfileURL1 !==''"-->
<!--                                        >-->
<!--                                        </v-img>-->
<!--                                        <v-img :src="require('../../public/img/icons/noimage2.png')"-->
<!--                                               v-else-->
<!--                                        >-->
<!--                                        </v-img>-->
<!--                                    </v-avatar>-->
<!--                                    <br>-->
<!--                                    <v-alert-->
<!--                                            v-if="errors_tutor1.avatar"-->
<!--                                            type="error"-->
<!--                                            outlined-->
<!--                                            transition="scale-transition"-->
<!--                                    >-->
<!--                                        {{errors_tutor1.avatar}}-->
<!--                                    </v-alert>-->
<!--                                    <br>-->
<!--                                    <v-btn-->
<!--                                            color="primary">-->
<!--                                        <clipper-upload-->
<!--                                                @input="dialog = false, dialogImageProfile1 = true, degrees = 0, ratio = 1.5"-->
<!--                                                accept="image/*"-->
<!--                                                v-model="imageProfileURL1"-->
<!--                                        >-->
<!--                                            {{$t('subir_imagen')}}-->
<!--                                        </clipper-upload>-->
<!--                                    </v-btn>-->
<!--                                </v-flex>-->
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br><h4>Tutor 2</h4>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="first_name2"
                                            prepend-icon="mdi-account"
                                            name="first_name2"
                                            :label="$t('Nombre')"
                                            :error-messages="errors_tutor2.first_name"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="last_name2"
                                            prepend-icon="mdi-account-outline"
                                            name="last_name2"
                                            :label="$t('Apellido')"
                                            :error-messages="errors_tutor2.last_name"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="email_2"
                                            prepend-icon="mdi-email"
                                            name="email_2"
                                            label="E-Mail"
                                            :error-messages="errors_tutor2.email"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            v-model="email_21"
                                            prepend-icon="mdi-email"
                                            name="email_21"
                                            :label="$t('email_confirm')"
                                            :error-messages="errors_tutor2.email"
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <vue-phone-number-input
                                            class="pl-3 pr-3"
                                            default-country-code="MX"
                                            color="#D32F2F"
                                            valid-color="#2196F3"
                                            @update="onChange2"
                                            v-model="cellphoneMundial2"
                                            :translations="custom_cell_phone"
                                    ></vue-phone-number-input>
                                    <v-alert outlined v-if="errors_tutor2.cellNumber" type="error">{{errors_tutor2.cellNumber}}</v-alert>
                                </v-flex>
                            </v-layout><br>
                            <v-layout row wrap class="text-center">
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            v-if="resultFrontURL2 !== ''"
                                            :src="resultFrontURL2"
                                            width="auto"
                                            height="200px"
                                    ></v-img>
                                    <v-img
                                            v-else
                                            :src="require('../../public/img/icons/noimage.png')"
                                            width="auto"
                                            height="200px"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errors_tutor2.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errors_tutor2.idFront}}
                                    </v-alert>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageFront2 = true, degrees = 0, ratio = 1.5"
                                                accept="image/*"
                                                v-model="imageFrontURL2"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                </v-flex>
<!--                                <v-flex xs12 sm4 class="edge pt-3 pb-3 pl-3 pr-3">-->
<!--                                    <v-label>-->
<!--                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]-->
<!--                                    </v-label>-->
<!--                                    <br>-->
<!--                                    <v-img-->
<!--                                            v-if="resultBackURL2 !==''"-->
<!--                                            :src="resultBackURL2"-->
<!--                                            width="auto"-->
<!--                                            height="200px"-->
<!--                                    ></v-img>-->
<!--                                    <v-img-->
<!--                                            v-else-->
<!--                                            :src="require('../../public/img/icons/noimage.png')"-->
<!--                                            width="auto"-->
<!--                                            height="200px"-->
<!--                                    ></v-img>-->
<!--                                    <br>-->
<!--                                    <v-alert-->
<!--                                            v-if="errors_tutor2.idBack"-->
<!--                                            type="error"-->
<!--                                            outlined-->
<!--                                            transition="scale-transition"-->
<!--                                    >-->
<!--                                        {{errors_tutor2.idBack}}-->
<!--                                    </v-alert>-->
<!--                                    <br>-->
<!--                                    <v-btn-->
<!--                                            color="primary">-->
<!--                                        <clipper-upload-->
<!--                                                @input="dialog = false, dialogImageBack2 = true, degrees = 0, ratio = 1.5"-->
<!--                                                accept="image/*"-->
<!--                                                v-model="imageBackURL2"-->
<!--                                        >-->
<!--                                            {{$t('subir_imagen')}}-->
<!--                                        </clipper-upload>-->
<!--                                    </v-btn>-->
<!--                                </v-flex>-->
<!--                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">-->
<!--                                    <v-label>-->
<!--                                        {{$t('foto_perfil')}}-->
<!--                                    </v-label>-->
<!--                                    <br>-->
<!--                                    <v-avatar-->
<!--                                            class="profile"-->
<!--                                            color="grey"-->
<!--                                            size="200"-->
<!--                                    >-->
<!--                                        <v-img :src="resultProfileURL2"-->
<!--                                               v-if="resultProfileURL2 !==''"-->
<!--                                        >-->
<!--                                        </v-img>-->
<!--                                        <v-img :src="require('../../public/img/icons/noimage2.png')"-->
<!--                                               v-else-->
<!--                                        >-->
<!--                                        </v-img>-->
<!--                                    </v-avatar>-->
<!--                                    <br>-->
<!--                                    <v-alert-->
<!--                                            v-if="errors_tutor2.avatar"-->
<!--                                            type="error"-->
<!--                                            outlined-->
<!--                                            transition="scale-transition"-->
<!--                                    >-->
<!--                                        {{errors_tutor2.avatar}}-->
<!--                                    </v-alert>-->
<!--                                    <br>-->
<!--                                    <v-btn-->
<!--                                            color="primary">-->
<!--                                        <clipper-upload-->
<!--                                                @input="dialog = false, dialogImageProfile2 = true, degrees = 0, ratio = 1.5"-->
<!--                                                accept="image/*"-->
<!--                                                v-model="imageProfileURL2"-->
<!--                                        >-->
<!--                                            {{$t('subir_imagen')}}-->
<!--                                        </clipper-upload>-->
<!--                                    </v-btn>-->
<!--                                </v-flex>-->
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <h3>{{$t('datos_estudiantes')}}</h3>
                            <br>
                            <v-btn
                                    color="primary"
                                    dark
                                    @click="cleanFields(), dialogStudent = true"
                            >+ {{$t('agregar_alumno')}}</v-btn>

                            <v-card-title>
                                {{$t('estudiante')}}(s)
                            </v-card-title>
                            <v-card-text>
                                <v-data-table
                                        :headers="headers"
                                        :items="students"
                                        class="elevation-1"
                                >
                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                                medium
                                                color="grey"
                                                class="mr-2"
                                                @click="editStudent(item)"
                                        >
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon
                                                medium
                                                color="red"
                                                @click="deleteResident(item)"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </v-data-table>
                                <br>
                                <v-divider></v-divider>
                                <br>
                                <v-btn
                                        color="primary"
                                        large
                                        @click="createTutuorAndStudents()"
                                >
                                    {{$t('enviar')}}
                                </v-btn>
                            </v-card-text>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {mapState} from "vuex";

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})
export default {
  name: 'signup_tutor',
  data: () => ({
    first_name: '',
    first_name2: '',
    last_name: '',
    last_name2: '',
    email: '',
    email_2: '',
    email_11: '',
    email_21: '',
    cellphone: '',
    cellphone_2: '',
    dialogStudent: false,
    editedIndex: -1,
    edit: false,
    section: '',
    sections: [
      {
        "id": "2da06199-3b24-49fd-88c1-29e2e1fc0f09",
        "name": "Apostólica Kinder",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logo_updatef48c978c-ca3d-421b-826f-1b1c26bf495c.jpeg",
        "url_map": "https://www.google.com/maps/place/Apost%C3%B3lica/@22.1852905,-101.075905,12z/data=!4m8!1m2!2m1!1sapost%C3%B3lica!3m4!1s0x842aa276aba23f2d:0x742f097c6e67ef1d!8m2!3d22.1217769!4d-100.9747239"
      },
      {
        "id": "a42aab80-6cf2-40fb-8fd3-0f4c25de6076",
        "name": "Apostólica Primaria",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logoc9d7329c-07cc-4885-8c59-793610625b7e.jpeg",
        "url_map": "https://goo.gl/maps/gxJan9R8vMXxsvoW6"
      },
      {
        "id": "8a68a3fd-753e-4bb4-9776-a411d1b541ac",
        "name": "Apostólica Secundaria",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logoc9d7329c-07cc-4885-8c59-793610625b7e.jpeg",
        "url_map": "https://goo.gl/maps/gxJan9R8vMXxsvoW6"
      },
      {
        "id": "114ed780-6ed9-4a32-bdaf-65aaa56e8011",
        "name": "Fidel Ferrer",
        "logo": "https://intrareesc.s3.amazonaws.com/static/Logos/logo_update41aa694c-56ac-4346-a9fb-3f93ee21ada4.jpeg",
        "url_map": "https://www.google.com/maps/place/22%C2%B009'03.5%22N+101%C2%B001'18.8%22W/@22.1509835,-101.0227753,18z/data=!3m1!4b1!4m5!3m4!1s0x0:0x0!8m2!3d22.1509815!4d-101.0218813"
      }
    ],
    editedItem: {
      idSchool: '',
      first_name: '',
      last_name: '',
      avatar: require('../../public/img/icons/noimage2.png')
    },
    defaultItem: {
      idSchool: '',
      first_name: '',
      last_name: '',
      avatar: require('../../public/img/icons/noimage2.png')
    },
    schools: [],
    nombre_calle: '',
    students: [],
    headers: [],
    cellphoneMundial1: '',
    cellphoneMundial2: '',
    dialogProgress: false,
    errores: [],
    imageProfile2URL: '',
    dialogImageProfileStudent: false,
    custom_cell_phone: { },
    band_cellphone1: false,
    cellphone_plus_country_code1: '',
    band_cellphone2: false,
    cellphone_plus_country_code2: '',
    // Photos Tutor 1
    dialogImageFront1: false,
    dialogImageBack1: false,
    dialogImageProfile1: false,
    imageFrontURL1: '',
    imageBackURL1: '',
    imageProfileURL1: '',
    resultFrontURL1: '',
    resultBackURL1: '',
    resultProfileURL1: '',
    // Photos Tutor 2
    dialogImageFront2: false,
    dialogImageBack2: false,
    dialogImageProfile2: false,
    imageFrontURL2: '',
    imageBackURL2: '',
    imageProfileURL2: '',
    resultFrontURL2: '',
    resultBackURL2: '',
    resultProfileURL2: '',
    resultProfile2URL: '',
    errors_tutor1: [],
    errors_tutor2: [],
    errors_student: [],
    dialogCellNumberWrong: false,
    bandNoStudentRegister: false,
    bandNoSchoolRegister: false,
    bandDifferentNumbers: false,
    degrees: 0,
    ratio: 1.5,
    bandDifferentEmail1: false,
    bandDifferentEmail2: false,
    search: null,
    entries: [],
    descriptionLimit: 60,
    checkUniqueTutor: false,
    isLoadingSchools: false,
    avatar: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAABgAAAAYADwa0LPAAADAklEQVRo3u2ZzWuTQRDGf01txRgt9uMgtTdREUoDausHHiw9edeq9SIiHtSrVr1brzWtWvwTxJNf4OfFk+hJEdGTNVhoFBRLSSskHnZfKDHvZmd334RiHphDks0zM7uzs7Oz0EQT/zdaAvG0AoPAIWAXsAPYDGT07wvAN+Aj8BZ4CbwGSo2egD7gOpAHykL5CkwAvY0wvAeYAZYcDK+UJeAm0FUv408APwIYXikF4GiShrcBdxIwvFKmgTWhjU8Dj+pgfCT3gXUhZ15ifBGYBIaA9VqGgBv6N4kTQVZCEjZ5YMDAlUWWsaZ9jR8TzvyABWdWuBLOG7sHWbaZFHDnBLwFHFPsjEBJGXUS22KvkFscSluQH1IZAX9GyF0k5sROxSg4D7RLvRZAWoOtBc7ZDm7FrbZJMoTKwCxVJrzaCgziVmCdFIwdc+DvA3bbDLziMDtRnGYt+LO4F4HjNg7ccySPDjKTE1ncwjOSuzYOvPdQUNazm0PFeUbLPv2db/n9zsaBJErlUFKoNLbaJpbk83pjg40DqwrVytUFoNOTt4S6xP/SnztQqdm3ifDbxoE5BweWgSfAc+AV8AFYrBiTBnYCB4ERLdLTfs5mkCSNfkGVHS4r1glcQJ2wQdPoZQuiP3pciHqpHbiqOWvpvWRDWKtOWQaGAxheiRHNbdK9x4YohWo6xZFcTMD4COOYw9U6a04YiJJsQHUb9F6TEJkuNKcSdOB0jM7YC40Jt2LIFlG1TWjs19zVdOZcCLuB7zGEP7XCUDigOavpmsfjYD1GfEwWgTOehrcAZzG3WY74zs5tA3kZeAr0O/D2A89qcE/5Gg+qtfiwhqISqv14HNho4OpAdbcf6/+YOK1ai7bFVRp1jB+2GFsCPgOfUHENsAnYBmzFLpc/AEb5t57yQhvxmSmkTNnMvA9GUTej0IbPE2DD2qIL1e6TNGlN2SyH/x3ECb2oskNSEkcyiyoPvB75Qj2zplBNp2HUM+t2bdjKZ9Y8amO/AV6gnlsb/szaRBOrHX8BTX7HyUOjY8oAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDItMTVUMDA6MzU6MDErMDA6MDByOxknAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTAyLTE1VDAwOjM1OjAxKzAwOjAwA2ahmwAAAABJRU5ErkJggg=='
  }),
  watch: {
    search (val) {
      console.log(val)
      // Items have already been loaded
      //if (this.items.length > 0) return

      // Items have already been requested
      //if (this.isLoading) return
      if (val !== null && val !== undefined) {
          if (val.length > 2) {
            this.isLoadingSchools = true
            // Lazily load input items
            HTTP.get('schools/filter?search=' + val, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => {
              console.log(response.data)
              if (this.entries.length > 0) {
                for (var i = 0; i < response.data.length; i++) {
                  this.entries.push(response.data[i])
                }
              } else
                this.entries = response.data
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => (this.isLoadingSchools = false))
          }
        }
      }
  },
  beforeUpdate () {
    this.custom_cell_phone ={
      "countrySelectorLabel": this.$t('codigo_pais'),
      "phoneNumberLabel": this.$t('celular'),
      "example": this.$t('ejemplo')
    },
        this.headers = [
          {
            text: this.$t('acciones'),
            align: 'center',
            value: 'action',
            sortable: false
          },
          {
            text: this.$t('Nombre'),
            align: 'center',
            sortable: true,
            value: 'first_name'
          },
          {
            text: this.$t('Apellido'),
            align: 'center',
            sortable: true,
            value: 'last_name'
          },
          // {
          //   text: this.$t('celular'),
          //   align: 'center',
          //   sortable: true,
          //   value: 'cellphone'
          // },
          // {
          //   text: 'E-Mail',
          //   align: 'center',
          //   sortable: true,
          //   value: 'email'
          // },
          // {
          //   text: this.$t('puede_enviar'),
          //   align: 'center',
          //   sortable: true,
          //   value: 'puede_enviar'
          // }
        ]
  },
  computed: {
    ...mapState(['language']),
    formTitle () {
      return this.editedIndex === -1 ? this.$t('agregar_alumno') : this.$t('editar_alumno')
    },
    items () {
      return this.entries.map(entry => {
        const name = entry.name.length > this.descriptionLimit
            ? entry.name.slice(0, this.descriptionLimit) + '...'
            : entry.name

        return Object.assign({}, entry, { name })
      })
    }
  },
  methods: {
    onChange1 (data) {
      this.cellphone_plus_country_code1 = data.formattedNumber
      this.band_cellphone1 = data.isValid
    },
    onChange2 (data) {
      console.log(data)
      this.cellphone_plus_country_code2 = data.formattedNumber
      this.band_cellphone2 = data.isValid
    },
    getSchools () {
      HTTP.get('school/no_permission/', {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        this.schools = response.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    addStudent () {
      // console.log(this.cellphoneMundial)
      if (this.editedIndex > -1) {
        Object.assign(this.students[this.editedIndex], this.editedItem)
      } else {
        this.students.push(this.editedItem)
        // console.log('Resident Added')
      }
      this.close()
    },
    editStudent (item) {
      this.editedIndex = this.students.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogStudent = true
    },
    deleteResident (aResident) {
      const index = this.students.indexOf(aResident)
      confirm('¿Está seguro de eliminar al Estudiante ' + aResident.first_name + ' ' + aResident.last_name + '?.\nEsta Acción no se puede deshacer!') && this.students.splice(index, 1)
    },
    close () {
      this.dialogStudent = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    cleanFields () {
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
      this.resultProfile2URL = ''
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    createTutuorAndStudents () {
      this.errors_tutor1 = []
      this.errors_tutor2 = []
      this.errors_student = []
      this.bandNoStudentRegister = false
      this.bandNoSchoolRegister = false
      this.bandDifferentNumbers = false
      console.log('bannd1 = ', this.band_cellphone1)
      console.log('bannd2 = ', this.band_cellphone2)
      if (this.band_cellphone1 === true && this.band_cellphone2 === true) {
        if(this.cellphone_plus_country_code1 !== this.cellphone_plus_country_code2) {
          if (this.email === this.email_11) {
            this.bandDifferentEmail1= false
            if (this.email_2 === this.email_21) {
              this.bandDifferentEmail2= false
              this.dialogProgress = true
              var bodyFormData = new FormData()
              var fileImageFront1 = null
              var fileImageBack1 = null
              var fileImageProfile1 = null

              var fileImageFront2 = null
              var fileImageBack2 = null
              var fileImageProfile2 = null

              var fileAvatar = null

              bodyFormData.set('idTutor1.first_name', this.first_name)
              bodyFormData.set('idTutor1.last_name', this.last_name)
              bodyFormData.set('idTutor1.cellNumber', this.cellphone_plus_country_code1)
              bodyFormData.set('idTutor1.email', this.email.toLowerCase())
              if (this.resultFrontURL1 !== '' && this.resultFrontURL1.length > 6) {
                const newID = this.$uuid.v4()
                fileImageFront1 = this.dataURLtoFile(this.resultFrontURL1, 'ine_front' + newID + '.jpeg')
                fileImageBack1 = this.dataURLtoFile(this.resultFrontURL1, 'ine_back' + newID + '.jpeg')
              }
              bodyFormData.append('idTutor1.idFront', fileImageFront1)
              bodyFormData.append('idTutor1.idBack', fileImageBack1)
              // if (this.resultBackURL1 !== '' && this.resultBackURL1.length > 6) {
              //   const newID = this.$uuid.v4()
              // }
              this.resultProfileURL1 = this.avatar
              if (this.resultProfileURL1 !== '' && this.resultProfileURL1.length > 6) {
                const newID = this.$uuid.v4()
                fileImageProfile1 = this.dataURLtoFile(this.resultProfileURL1, 'avatar' + newID + '.jpeg')
              }
              bodyFormData.append('idTutor1.avatar', fileImageProfile1)

              bodyFormData.set('idTutor2.first_name', this.first_name2)
              bodyFormData.set('idTutor2.last_name', this.last_name2)
              bodyFormData.set('idTutor2.cellNumber', this.cellphone_plus_country_code2)
              bodyFormData.set('idTutor2.email', this.email_2.toLowerCase())
              if (this.resultFrontURL2 !== '' && this.resultFrontURL2.length > 6) {
                const newID = this.$uuid.v4()
                fileImageFront2 = this.dataURLtoFile(this.resultFrontURL2, 'ine_front' + newID + '.jpeg')
                fileImageBack2 = this.dataURLtoFile(this.resultFrontURL2, 'ine_back' + newID + '.jpeg')
              }
              bodyFormData.append('idTutor2.idFront', fileImageFront2)
              bodyFormData.append('idTutor2.idBack', fileImageBack2)
              // if (this.resultBackURL2 !== '' && this.resultBackURL2.length > 6) {
              //   const newID = this.$uuid.v4()
              // }
              this.resultProfileURL2 = this.avatar
              if (this.resultProfileURL2 !== '' && this.resultProfileURL2.length > 6) {
                const newID = this.$uuid.v4()
                fileImageProfile2 = this.dataURLtoFile(this.resultProfileURL2, 'avatar' + newID + '.jpeg')
              }
              bodyFormData.append('idTutor2.avatar', fileImageProfile2)

              for (var i = 0; i < this.students.length; i++) {
                bodyFormData.set('student[' + i + ']first_name', this.students[i].first_name)
                bodyFormData.set('student[' + i + ']last_name', this.students[i].last_name)
                // console.log(this.students[i].avatar)
                if (this.students[i].avatar !== '' && this.students[i].avatar.length > 6) {
                  const newID = this.$uuid.v4()
                  fileAvatar = this.dataURLtoFile(this.students[i].avatar, 'avatar' + newID + '.jpeg')
                  // console.log('HOLA')
                }
                bodyFormData.append('student[' + i + ']avatar', fileAvatar)
                bodyFormData.set('student[' + i + ']idSchool', this.students[i].idSchool)
              }
              HTTP.post('preregistration/webapp/', bodyFormData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Accept-Language': this.language
                }
              })
                  .then(ok => {
                    console.log(ok)
                    console.log('Datos Dados de Alta Correctamente')
                    // this.getGuards()
                    // this.$store.commit('snackbar_activate_true')
                    // this.$store.commit('snackbar_change_message', this.$t('mensaje_vigilante_alta'))
                    // this.dialog = false
                    // setTimeout(this.clear, 3000)
                    this.dialogProgress = false
                    this.$router.push({path: '/signup_tutor_success'})
                  })
                  .catch(error => {
                    this.dialogProgress = false
                    if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
                      if (error.response.data) {
                        this.errores = error.response.data
                        console.log(this.errores)
                      }
                      if (error.response.data.idTutor1) {
                        this.errors_tutor1 = error.response.data.idTutor1
                      }
                      if (error.response.data.idTutor2) {
                        this.errors_tutor2 = error.response.data.idTutor2
                      }
                      if (error.response.data.student) {
                        if (error.response.data.student[0].idSchool) {
                          this.bandNoSchoolRegister = true
                          this.dialogCellNumberWrong = true
                          console.log('Debe seleccionar una Escuela, del Catálogo')
                        } else {
                          this.bandNoStudentRegister = true
                          this.dialogCellNumberWrong = true
                          console.log('Debes de dar de Alta al menos un estudiante')
                        }
                      }
                    }
                  })
            } else {
              this.bandDifferentEmail2= true
              this.dialogCellNumberWrong = true
            }
          } else {
            this.bandDifferentEmail1= true
            this.dialogCellNumberWrong = true
          }
        } else {
          this.bandDifferentNumbers = true
          this.dialogCellNumberWrong = true
        }
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    getCutingFront1 () {
      // console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront1.clip({ wPixel: 500 }) // call component's clip method
      this.resultFrontURL1 = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log('BASE64 = ', this.resultFrontURL)
      this.dialogImageFront1 = false
    },
    getCutingBack1 () {
      const canvas = this.$refs.clipperImageBack1.clip({ wPixel: 500 }) // call component's clip method
      this.resultBackURL1 = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultBackURL)
      this.dialogImageBack1 = false
    },
    getCutingProfile1 () {
      const canvas = this.$refs.clipperImageProfile1.clip({ wPixel: 300 }) // call component's clip method
      this.resultProfileURL1 = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultProfileURL)
      this.dialogImageProfile1 = false
    },
    getCutingFront2 () {
      // console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront2.clip({ wPixel: 500 }) // call component's clip method
      this.resultFrontURL2 = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log('BASE64 = ', this.resultFrontURL)
      this.dialogImageFront2 = false
    },
    getCutingBack2 () {
      const canvas = this.$refs.clipperImageBack2.clip({ wPixel: 500 }) // call component's clip method
      this.resultBackURL2 = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultBackURL)
      this.dialogImageBack2 = false
    },
    getCutingProfile2 () {
      const canvas = this.$refs.clipperImageProfile2.clip({ wPixel: 300 }) // call component's clip method
      this.resultProfileURL2 = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultProfileURL)
      this.dialogImageProfile2 = false
    },
    getCutingProfileStudent () {
      const canvas = this.$refs.clipperImageProfile3.clip({ wPixel: 300 }) // call component's clip method
      this.resultProfile2URL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      // console.log(this.resultProfile2URL)
      this.editedItem.avatar = this.resultProfile2URL
      this.dialogImageProfileStudent = false
      this.dialogStudent = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    customFilter (item, queryText) {
      const textOne = item.name.toLowerCase()
      if (queryText.length > 3) {
        const searchText = queryText.toLowerCase()
        return textOne.indexOf(searchText) > -1
      }
    },
  }
}
</script>

<style scoped>
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
